import { getAuthState } from '@wajeez-web/stores/auth';
import { store } from '@wajeez-web/stores/base';
const HasPermission = (permissions: string | string[]) => {
  if (Array.isArray(permissions)) {
    return permissions.find((item) =>
      getAuthState(store).permission?.includes(item)
    );
  } else if (getAuthState(store).permission?.includes(permissions)) {
    return true;
  } else return false;
};

export default HasPermission;
